/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ErrorHandlerInterceptor } from './error-handler.interceptor';
import { ResponseMockInterceptor } from './response-mock.interceptor';

export const httpInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ResponseMockInterceptor, multi: true }
];
